// Lib
import React from 'react';
import { AppBar } from '@mui/material';

// Components
import ContentOnlyHeader from './ContentOnlyHeader';
import HeaderToolbar from './HeaderToolbar';
import HeaderSideMenu from './HeaderSideMenu';
import MobileSearch from '../../Search/MobileSearch';

// Hooks
import useHeader from './useHeader';

const Header = ({
  isKiteUser = true,
  isAuthPage,
  isLoggedIn,
  onlyLogoLink,
  searchResults,
  onChangeSearch,
  onlyContent,
  title,
}) => {
  const headerProps = useHeader({
    isKiteUser,
    isAuthPage,
    isLoggedIn,
    onlyLogoLink,
    onlyContent,
  });
  const {
    classes,
    isDesktopMode,
    isMobileMode,
    isActiveSearch,
    onToggleSearchInput,
    onChange,
    searchValue,
    onClearSearch,
    pathname,
  } = headerProps;

  return (
    <AppBar className={classes.root} position="sticky">
      {onlyContent ? (
        <ContentOnlyHeader
          isDesktopMode={isDesktopMode}
          isMobileMode={isMobileMode}
          classes={classes}
          title={title}
          onToggleSearchInput={onToggleSearchInput}
        />
      ) : (
        <>
          <HeaderToolbar
            {...headerProps}
            isAuthPage={isAuthPage}
            onlyLogoLink={onlyLogoLink}
          />
          <HeaderSideMenu {...headerProps} isKiteUser={isKiteUser} />
        </>
      )}
      <MobileSearch
        options={searchResults}
        withMenu={
          pathname.includes('address-book') ||
          pathname.includes('cart/shipping-address')
        }
        value={searchValue}
        onChange={onChangeSearch || onChange}
        isActive={isActiveSearch}
        onToggleSearchInput={onToggleSearchInput}
        onClearSearch={onClearSearch}
      />
    </AppBar>
  );
};

export default Header;
